import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row no-wrap items-start" }
const _hoisted_2 = {
  key: 3,
  class: "q-ml-lg"
}
const _hoisted_3 = { class: "text-bold text-caption q-mb-xs q-ml-sm" }
const _hoisted_4 = {
  key: 4,
  class: "q-ml-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mosta_checkbox = _resolveComponent("mosta-checkbox")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_selected_list_element = _resolveComponent("selected-list-element", true)!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_date_range_column_display_item = _resolveComponent("date-range-column-display-item")!
  const _component_dnd_reorder_element = _resolveComponent("dnd-reorder-element")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["selected-list-element-root", { 'selected-list-element-root--group': _ctx.isGroup }]),
    style: {"position":"relative"}
  }, [
    (!_ctx.draggable)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`grouped-element${_ctx.isFirst ? '-first' : (_ctx.isLast ? '-last' : '-center')}`),
          style: _normalizeStyle(_ctx.groupingMode ? 'padding-left: 18px;' : 'padding-left: 18px;')
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.isSelectable)
              ? (_openBlock(), _createBlock(_component_mosta_checkbox, {
                  key: 0,
                  class: "q-ml-xs my-check",
                  disable: _ctx.element.AlwaysSelected,
                  modelValue: _ctx.elementModel.Selected,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.elementModel.Selected) = $event)),
                  label: _ctx.element.GroupId && _ctx.element.GroupId > 0 ? '' : _ctx.getElementName
                }, null, 8, ["disable", "modelValue", "label"]))
              : _createCommentVNode("", true),
            (_ctx.element.GroupId && _ctx.element.GroupId > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                  class: "text-grey-6",
                  style: {"margin-left":"6px"}
                }, _toDisplayString(_ctx.getElementName), 1))
              : _createCommentVNode("", true)
          ])
        ], 6))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "row justify-left full-width q-py-none no-wrap",
          style: _normalizeStyle(!_ctx.groupingMode && !(_ctx.element.sub_items && _ctx.element.sub_items.length) && _ctx.isSelectable ? 'padding-left: 18px;' : '')
        }, [
          (!(_ctx.element.sub_items && _ctx.element.sub_items.length) && _ctx.isSelectable && _ctx.groupingMode)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: _ctx.hovered || _ctx.grouped ? 'primary' : 'white',
                rounded: "",
                style: {"min-width":"10px","min-height":"10px","max-width":"10px","max-height":"10px","border":"1px solid grey","cursor":"pointer"},
                class: "q-pa-none q-my-xs q-mr-sm",
                onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mouseover())),
                onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mouseleave())),
                onClick: _ctx.clickBadge
              }, null, 8, ["color", "onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_dnd_reorder_element, {
            id: undefined,
            index: _ctx.inputIndex,
            "highlight-condition": _ctx.allowHoverAction,
            "hover-condition": () => false,
            CtcDropCondition: _ctx.allowHoverAction,
            CtrDropCondition: () => false,
            RtrDropCondition: () => false,
            type: _ctx.elDragType,
            "into-allowed": false,
            "grouping-mode": _ctx.groupingMode,
            "callback-params": { parent_id: _ctx.parentId, isRoot: false, elType: 5, viewport: _ctx.scrollViewport },
            onChangePosition: _ctx.moveStoreItem,
            draggable: "true",
            class: "dnd-element display-ungroup-on-hover"
          }, {
            default: _withCtx(() => [
              (_ctx.element.sub_items && _ctx.element.sub_items.length)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    class: "q-my-none q-pa-xs text-left text-md ungroup-btn unset-items-center",
                    style: {"position":"absolute","top":"5px","right":"5px","z-index":"10"},
                    "no-caps": "",
                    align: "left",
                    size: "xs",
                    color: "grey-8",
                    icon: "open_with",
                    "aria-label": _ctx.$t('choose_upcase'),
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.onUnGroupClick(_ctx.element.sub_items[0].GroupId)), ["stop","prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, {
                        delay: 1000,
                        anchor: "top middle",
                        self: "center middle"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('ungroup')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["aria-label"]))
                : _createCommentVNode("", true),
              (!(_ctx.element.sub_items && _ctx.element.sub_items.length) && _ctx.isSelectable)
                ? (_openBlock(), _createBlock(_component_mosta_checkbox, {
                    key: 1,
                    class: "q-ml-xs my-check",
                    modelValue: _ctx.elementModel.Selected,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.elementModel.Selected) = $event)),
                    label: _ctx.getElementName,
                    disable: _ctx.element.AlwaysSelected
                  }, null, 8, ["modelValue", "label", "disable"]))
                : (_ctx.isSelectable)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.element.sub_items, (sub, sub_index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "row no-wrap display-delgroup-on-hover",
                        key: (_ctx.parentIdx || '')+sub_index+'_g'+sub.GroupId+'_'+sub.compound_name
                      }, [
                        _createVNode(_component_selected_list_element, {
                          element: sub,
                          "input-index": sub_index,
                          "parent-id": undefined,
                          "parent-name": '',
                          "parent-idx": sub_index,
                          "is-root": true,
                          "grouping-mode": _ctx.groupingMode,
                          "is-first": sub_index === 0 || _ctx.element.sub_items && !(_ctx.element.sub_items[sub_index-1] as any).group_id && (sub as any).group_id,
                          "is-last": _ctx.element.sub_items && ((sub_index === _ctx.element.sub_items.length-1) || 
              _ctx.element.sub_items[sub_index+1] && !(_ctx.element.sub_items[sub_index+1] as any).group_id && (sub as any).group_id),
                          "allow-hover-action": () => false,
                          onChangePosition: () => false,
                          onChangeSelection: _ctx.onChildSelectionUpdate,
                          onTogglesChange: _ctx.onTogglesChange,
                          onRangeChange: _ctx.onRangeChange,
                          onUnGroupClick: _ctx.onUnGroupClick,
                          onUnGroupSingleClick: _ctx.onUnGroupSingleClick,
                          "scroll-viewport": _ctx.scrollViewport
                        }, null, 8, ["element", "input-index", "parent-idx", "grouping-mode", "is-first", "is-last", "onChangeSelection", "onTogglesChange", "onRangeChange", "onUnGroupClick", "onUnGroupSingleClick", "scroll-viewport"]),
                        (_ctx.element.sub_items && _ctx.element.sub_items.length)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              class: "q-ml-sm text-left text-md delgroup-btn unset-items-center",
                              style: {"margin-top":"-2px"},
                              "no-caps": "",
                              align: "left",
                              size: "xs",
                              color: "grey-8",
                              flat: "",
                              round: "",
                              icon: "close",
                              "aria-label": _ctx.$t('choose_upcase'),
                              onClick: _withModifiers(($event: any) => (_ctx.onUnGroupSingleClick((sub as ColumnListItem).GroupId, (sub as ColumnListItem).compound_id)), ["stop","prevent"])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tooltip, {
                                  delay: 1000,
                                  anchor: "top middle",
                                  self: "center middle"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('remove_from_group')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["aria-label", "onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true),
              ((_ctx.element as ColumnSendWithOptions).ToggleArrays)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_q_expansion_item, {
                      dense: "",
                      flat: "",
                      "default-opened": false,
                      label: _ctx.$t('options_label'),
                      class: "q-ma-none q-pa-none"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.element as ColumnSendWithOptions).ToggleArrays, (array, toggle_ai) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: (_ctx.parentIdx || '')+'_tar_'+toggle_ai
                          }, [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.toggleArrayTypeToList(array.Type)), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(array.Toggles, (toggle, toggle_i) => {
                              return (_openBlock(), _createBlock(_component_q_toggle, {
                                key: (_ctx.parentIdx || '')+'_t_'+toggle_i,
                                modelValue: toggle.ToggledOn,
                                "onUpdate:modelValue": [($event: any) => ((toggle.ToggledOn) = $event), (val) => { _ctx.onToggleChange(val, toggle_i, toggle_ai) }],
                                class: "q-mr-xs q-ml-none text-caption",
                                "checked-icon": "add",
                                color: "primary",
                                label: (toggle.Type === 0 ? (toggle.Entity ? toggle.Entity.Name : '') : _ctx.toggleTypeToList(toggle.Type)),
                                size: "xs",
                                "unchecked-icon": "remove"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
                            }), 128))
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]))
                : _createCommentVNode("", true),
              ((_ctx.element as ColumnSend).Descriptor === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_q_expansion_item, {
                      dense: "",
                      flat: "",
                      "default-opened": false,
                      label: _ctx.$t('options_label'),
                      class: "q-ma-none q-pa-none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_date_range_column_display_item, {
                          modelValue: _ctx.elementModel,
                          "onUpdate:modelValue": [
                            _cache[6] || (_cache[6] = ($event: any) => ((_ctx.elementModel) = $event)),
                            _ctx.onRangeChange
                          ]
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["index", "highlight-condition", "CtcDropCondition", "type", "grouping-mode", "callback-params", "onChangePosition"])
        ], 4))
  ], 2))
}